import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const DialSettingsIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M11.1067 8.43411V0.992248C11.1067 0.718247 11.3297 0.496124 11.6047 0.496124C11.8798 0.496124 12.1028 0.718247 12.1028 0.992248V8.43411C12.1028 8.70811 11.8798 8.93023 11.6047 8.93023C11.3297 8.93023 11.1067 8.70811 11.1067 8.43411Z"
      fill="currentColor"
    />
    <path
      d="M11.1066 14.8837V12.4031C11.1066 12.1291 11.3296 11.907 11.6046 11.907C11.8797 11.907 12.1027 12.1291 12.1027 12.4031V14.8837C12.1027 15.1577 11.8797 15.3799 11.6046 15.3799C11.3296 15.3799 11.1066 15.1577 11.1066 14.8837Z"
      fill="currentColor"
    />
    <path
      d="M12.8996 10.4186C12.8996 9.7336 12.3422 9.1783 11.6545 9.1783C10.9668 9.1783 10.4093 9.7336 10.4093 10.4186C10.4093 11.1036 10.9668 11.6589 11.6545 11.6589C12.3422 11.6589 12.8996 11.1036 12.8996 10.4186ZM13.8957 10.4186C13.8957 11.6516 12.8923 12.6512 11.6545 12.6512C10.4167 12.6512 9.41324 11.6516 9.41324 10.4186C9.41324 9.1856 10.4167 8.18605 11.6545 8.18605C12.8923 8.18605 13.8957 9.1856 13.8957 10.4186Z"
      fill="currentColor"
    />
    <path
      d="M3.6358 2.97674V0.992248C3.6358 0.718247 3.85879 0.496124 4.13386 0.496124C4.40893 0.496124 4.63191 0.718247 4.63191 0.992248V2.97674C4.63191 3.25075 4.40893 3.47287 4.13386 3.47287C3.85879 3.47287 3.6358 3.25075 3.6358 2.97674Z"
      fill="currentColor"
    />
    <path
      d="M3.63571 14.7849V6.94574C3.63571 6.67174 3.8587 6.44962 4.13377 6.44962C4.40883 6.44962 4.63182 6.67174 4.63182 6.94574V14.7849C4.63161 15.0587 4.4087 15.281 4.13377 15.281C3.85883 15.281 3.63592 15.0587 3.63571 14.7849Z"
      fill="currentColor"
    />
    <path
      d="M5.37899 4.75C5.37899 4.06233 4.82152 3.50487 4.13385 3.50487C3.44618 3.50487 2.88872 4.06233 2.88872 4.75C2.88872 5.43767 3.44618 5.99514 4.13385 5.99514C4.82152 5.99514 5.37899 5.43767 5.37899 4.75ZM6.3751 4.75C6.3751 5.98781 5.37166 6.99125 4.13385 6.99125C2.89605 6.99125 1.89261 5.98781 1.89261 4.75C1.89261 3.5122 2.89605 2.50876 4.13385 2.50876C5.37166 2.50876 6.3751 3.5122 6.3751 4.75Z"
      fill="currentColor"
    />
  </svg>
);
